import { StyleConfigMap } from "@app/config/credit-config";

export interface KycState {
  id: number;
  name: string;
}

 export enum KycStates {
  VALID = 'VALID',
  INVALID = 'INVALID',
  INVALID_MISSING = 'INVALID_MISSING',
  INVALID_IN_PROGRESS = 'INVALID_IN_PROGRESS',
  INVALID_IN_REVIEW = 'INVALID_IN_REVIEW',
  INVALID_ID_EXPIRED = 'INVALID_ID_EXPIRED',
}

export const KYC_STATE_STYLE_MAP: StyleConfigMap = {
  [KycStates.VALID]: { backgroundColor: '#43a047', icon: 'verified_user' },
  [KycStates.INVALID]: { backgroundColor: '#e53935', icon: 'gpp_bad' },
  [KycStates.INVALID_MISSING]: { backgroundColor: '#757575', icon: 'shield_question' },
  [KycStates.INVALID_IN_PROGRESS]: { backgroundColor: '#2353ef', icon: 'autorenew' },
  [KycStates.INVALID_IN_REVIEW]: { backgroundColor: '#f18408', icon: 'pending_actions' },
  [KycStates.INVALID_ID_EXPIRED]: { backgroundColor: '#9c27b0', icon: 'credit_card_clock' },
};

export const STATE_OPTIONS: KycStateOption[] = [
    { value: KycStates.VALID, icon: 'verified_user', color: '#43a047' },
    { value: KycStates.INVALID, icon: 'gpp_bad', color: '#e53935' },
    { value: KycStates.INVALID_MISSING, icon: 'shield_question', color: '#757575' },
    { value: KycStates.INVALID_IN_PROGRESS, icon: 'autorenew', color: '#2353ef' },
    { value: KycStates.INVALID_IN_REVIEW, icon: 'pending_actions', color: '#f18408' },
    { value: KycStates.INVALID_ID_EXPIRED, icon: 'credit_card_clock', color: '#9c27b0' },
  ];

export interface KycStateOption {
  value: KycStates;
  icon: string;
  color: string;
}

export interface KycStateEditDialogData {
  civilId: string;
  brandCode: string;
  currentState: KycStates;
}
